import { DataBean } from "../DataBean";

export class GuideLiquidator extends DataBean {

    public async getTransportGuideLiquidatorConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportGuideLiquidatorConstants_Number", [args]);
    }

}